import React from 'react';

const FRQTextNote = () => (
  <div>
    <p className="text-2xl font-medium text-blue text-bluebook-gray-900 leading-9">
      <span className="py-[4px] px-[8px] bg-black text-white rounded-md mr-3">
        Note
      </span>
      On your AP Exam, you will handwrite your responses to free-response
      questions in a test booklet
    </p>
  </div>
);

export default FRQTextNote;
